const menu = require('../../../../../components/menu/menu')
const dtHandler = require('../../../../../components/dt/dt-handler')

export function start(detail, htmlDt, htmlFc) {
      const menuElem = menuBody[detail.id]

      for (let i = 0; i < menuElem.length; i++) {
            menuElem[i].start(detail, htmlDt, htmlFc)
      }

      detail.html = menuElem
      detail.act = 'show'
      menu.start(detail)
}

const menuBody = {
      trMenu: [
            {
                  text: '',
                  svg: 'eye',
                  class: '',
                  dataDetail: '',
                  start: function (detail) {
                        this.text = 'View/Edit'
                        this.dataDetail = `data-detail='{"click": [
                              {"dest":"ripple"},
                              {"dest":"menu", "act":"hide"},
                              {"dest":"retail", "elem":"fullcont", "id":"retail-fullcont", "act":"selectOne", "entity":"retail", "dbid":"${detail.dbid}"}
                        ]}'`
                  },
            },
            {
                  text: '',
                  svg: 'receipt',
                  class: '',
                  dataDetail: '',
                  start: function (detail) {
                        this.text = 'Invoice'
                        this.dataDetail = `data-detail='{"click": [
                              {"dest":"ripple"},
                              {"dest":"menu", "act":"hide"},
                              {"dest":"retail", "elem":"dt", "act":"pdfMenudt", "entity":"retail", "report":"retail-invoice", "dbid":"${detail.dbid}"}
                        ]}'`
                  },
            },
            { text: 'line', start: function () {} },
            {
                  text: '',
                  svg: 'delete',
                  class: '',
                  dataDetail: '',
                  start: function (detail) {
                        this.text = 'Delete'
                        this.dataDetail = `data-detail='{"click": [
                              {"dest":"ripple"},
                              {"dest":"menu", "act":"hide"},
                              {"dest":"retail", "elem":"fullcont", "act":"deleteEntity", "entity":"retail", "dbid":["${detail.dbid}"]}
                        ]}'`
                  },
            },
      ],

      tableOptions: [
            {
                  text: '',
                  svg: 'delete-o',
                  class: '',
                  dataDetail: '',
                  start: function () {
                        this.text = 'Retail Deleted'
                        this.dataDetail = `data-detail='{"click": [
                              {"dest":"ripple"},
                              {"dest":"menu", "act":"hide"},
                              {"dest":"retailDeleted", "elem":"page", "id":"retailDeleted-page", "act":"show", "leftnav":"leftnav-sale-page"}
                        ]}'`
                  },
            },
            { text: 'line', start: function () {} },
            {
                  text: '',
                  svg: 'delete',
                  class: '',
                  dataDetail: '',
                  start: function (detail, htmlDt) {
                        const ids = dtHandler.getTrChecked(htmlDt)

                        if (ids.length > 0) {
                              this.class = ''
                              this.text = `Delete All (${ids.length})`
                              this.dataDetail = `data-detail='{"click": [
                                    {"dest":"ripple"},
                                    {"dest":"menu", "act":"hide"},
                                    {"dest":"retail", "elem":"fullcont", "act":"deleteEntity", "entity":"retail", "dbid":[${ids}]}
                              ]}'`
                        } else {
                              this.class = 'disabled'
                              this.text = 'Delete All'
                              this.dataDetail = ''
                        }
                  },
            },
      ],
}
